import Link from "next/link";
import Image from "next/image";

export default function HeaderLogo() {
  return (
    <Link href="/" data-testid="headerLogoLink">
      <Image
        alt="Rawiah"
        src="/images/RawiahLogos/headerlogo.svg"
        width={100}
        height={100}
        unoptimized
        priority={true}
        loading="eager"
        className="w-28 md:w-44"
      />
    </Link>
  );
}
